import { render, staticRenderFns } from "./ProductIntroductionItem.vue?vue&type=template&id=11cfe4be&"
import script from "./ProductIntroductionItem.vue?vue&type=script&lang=js&"
export * from "./ProductIntroductionItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntroductionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports